import { TaskCompletedDateFragment } from "gql/graphql";
import { DateTimeFormatter } from "@/shared/formatters";
import { Hidable, Value, Nothing } from "@/shared/value";
import { getTaskCompletedDate } from "../completion";

/**
 * Когда задачу выполнили. Пустая дата — задача ещё в работе (или это серия, у которой
 * отмечаются итерации, а не задача целиком), показывать нечего.
 */
export function TaskCompletedDate({
  data,
}: {
  data?: Hidable<TaskCompletedDateFragment>;
}) {
  return (
    <Value data={data}>
      {(task) => {
        const completedDate = getTaskCompletedDate(task);

        if (!completedDate) {
          return <Nothing />;
        }

        return <DateTimeFormatter value={new Date(completedDate)} />;
      }}
    </Value>
  );
}
